




















































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { ShakenShohiyou } from "@/model/shakenShohiyou";
import { Getter, Action } from "vuex-class";
/** 2023-10-19 invoice [START] */
import requestService from "@/service/requestService";
/** 2023-10-19 invoice [END] */
import { INSPECT_TYPE } from "@/model/InspectType";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import * as util from "@/service/util";
import { MESSAGE } from "@/model/Message";
import ButtonInspectResult from "@/components/common/button/ButtonInspectResult.vue";
import Number from "@/shared/filters/Number.ts";

export interface SideTab {
  isActive?: boolean;
  isConfirm?: boolean;
}

@Component({
  components: {
    appInputNumber: InputNumber,
    appButtonInspectResult: ButtonInspectResult
  },
  filters: {
    Number
  }
})
export default class SideTabRight extends Vue {
  /** 2023-10-19 invoice [START] */
  reqService: requestService;
  /** 2023-10-19 invoice [END] */
  sktControll: SocketControllers;


  @Prop() discountCoupon: any;
  @Prop() disabled: boolean;

  @Getter("sumPriceByType", { namespace: "InspectSeibi" })
  sumPrice!: (inspectType: number) => any;

  @Getter("isConfirmLegal56", { namespace: "InspectSeibi" })
  isConfirmLegal56: any;

  @Getter("isConfirmRecommend", { namespace: "InspectSeibi" })
  isConfirmRecommend: any;

  @Getter("total", { namespace: "Shohiyou" })
  totalShohiyou: any;

  /** 2023-10-19 invoice [START] */
  @Getter("shohiyouZn", { namespace: "Shohiyou" })
  subShohiyou: any;
  /** 2023-10-19 invoice [END] */

  @Getter("total", { namespace: "Coupon" })
  totalCoupon: any;

  @Getter("stateId", { namespace: "SubHeader" })
  stateId: number;

  @Getter("waitPartsSelect", { namespace: "SubHeader" })
  waitPartsSelect: boolean;

  @Getter("isConfirm", { namespace: "Payment" })
  isConfirmPayment: number;

  @Action("editPrice", { namespace: "InspectSeibi" })
  editPrice: any;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;

  @Getter("total", { namespace: "Option" })
  totalOption: any;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */

  sideTab: SideTab[] = [
    {
      isActive: false,
      isConfirm: false
    },
    {
      isActive: false,
      isConfirm: false
    },
    {
      isActive: false,
      isConfirm: false
    },
    {
      isActive: false,
      isConfirm: false
    },
    {
      isActive: false,
      isConfirm: false
    },
    {
      isActive: false,
      isConfirm: false
    }
  ];

  sumLegal56: any = {
    totalZk: 0,
    totalZn: 0,
    isConfirm: 0
  };

  sumRecommend: any = {
    totalZk: 0,
    totalZn: 0,
    isConfirm: 0
  };
  hasBtn: boolean = false;

  isOnPlus = [false, false, false, false, false];
  /** 2023-10-23 disp uchizei (invoice part 8) [START] */
  sumZnCalcZk: number = 0;
  /** 2023-10-23 disp uchizei (invoice part 8) [END] */

  created() {
    if (this.$route.name == "statusresult") {
      this.hasBtn = false;
    } else {
      this.hasBtn = true;
    }
    if (!(this.sideTab[2].isActive || this.sideTab[3].isActive)) {
      this.sktControll = new SocketControllers();
      this.sktControll.connectSocket(this.onConnect);
    }
    /** 2023-10-23 disp uchizei (invoice part 8) [START] */
    this.reqService = new requestService();
    /** 2023-10-23 disp uchizei (invoice part 8) [END] */
  }

  onConnect() {
    if (this.sktControll.checkSocket()) {
      this.sktControll.socketCustomerEditPrice(this.onEditPrice);
    }
  }

  setSumPriceLegal56() {
    this.$set(this, "sumLegal56", this.sumPrice(INSPECT_TYPE.LEGAL56));
  }

  get sumPriceLegal56() {
    this.setSumPriceLegal56();
    return this.sumLegal56;
  }

  setSumRecommend() {
    this.$set(this, "sumRecommend", this.sumPrice(INSPECT_TYPE.RECOMMEND));
  }

  get sumPriceRecommend() {
    this.setSumRecommend();
    return this.sumRecommend;
  }

  get sum() { //税込みの合算
    return (
      +this.totalShohiyou.totalZk +
      +this.totalCoupon.subTotalZk +
      +this.sumPriceRecommend.totalZk +
      +this.sumPriceLegal56.totalZk
      + +this.totalOption.subTotalZk
    );
  }

  get sumZn() { //税抜きの合算
    return (
      +this.totalShohiyou.totalZn +
      +this.totalCoupon.subTotalZn +
      +this.sumPriceRecommend.totalZn +
      +this.sumPriceLegal56.totalZn
      + +this.totalOption.subTotalZn
    );
  }

  /** 2023-10-23 disp uchizei (invoice part 8) [START] */
  get sumCalc(){
    this.sumCalcZk();
    return this.sumZnCalcZk;
  }

  /** 2023-10-19 invoice [START] */
  sumCalcZk() { //税抜きの合算から税込み計算

    this.reqService.getZeikomi(
      this.sumCalcKazeiZn
    ).then(
      (res: any) => {
        if (res) {
          this.$set(this, "sumZnCalcZk", res.priceZk + this.sumCalcHikazeiZn);
        }
      },
      (err: any) => {}
    );

  }

  get sumCalcKazeiZn() { //税抜きの合算から課税項目を合算

    return (
      +this.subShohiyou.subTotalKazei +
      +this.totalCoupon.subTotalZn +
      +this.sumPriceRecommend.totalZn +
      +this.sumPriceLegal56.totalZn
      + +this.totalOption.subTotalZn
    );

  }

  get sumCalcHikazeiZn() { //税抜きの合算から非課税項目を合算

    return this.subShohiyou.subTotalHikazei;

  }
  /** 2023-10-23 disp uchizei (invoice part 8) [END] */
  /** 2023-10-19 invoice [END] */

  // get sumTax() {
  //   return this.sum - this.sumZn;
  // }

  // get tax0() {
  //   return this.totalShohiyou.totalZk - this.totalShohiyou.totalZn;
  // }

  // get tax1() {
  //   return this.totalCoupon.subTotalZk - this.totalCoupon.subTotalZn;
  // }

  // get tax2() {
  //   return this.sumPriceLegal56.totalZk - this.sumPriceLegal56.totalZn;
  // }

  // get tax3() {
  //   return this.sumPriceRecommend.totalZk - this.sumPriceRecommend.totalZn;
  // }

  onActive(num: number) {
    this.sideTab[num].isActive = true;
    this.sideTab.forEach((tab: any, i: number) => {
      if (i != num) {
        tab.isActive = false;
      }
    });
  }

  onSelect(num: number) {
    this.$emit('onSelect');
    this.onActive(num);
    if (num == 0) {
      this.$router.push({ name: "inspectioncost" });
    } else if (num == 1) {
      this.$router.push({ name: "discountcoupon" });
    } else if (num == 2) {
      this.$router.push({ name: "userlegal56" });
    } else if (num == 3) {
      this.$router.push({ name: "userrecommend" });
    } else if (num == 4) {
      this.$router.push({ name: "paymentdetail" });
    } else if (num == 5) {
      this.$router.push({ name: "option" });
    }
    // const userService = new UserService();
    // userService.getDataToSync();
  }

  onConfirm(index: number) {
    this.sideTab[index].isConfirm = true;
    this.onUpdate(index);
  }

  onUpdate(index: number) {
    if (index == 2) {
      this.setSumPriceLegal56();
    } else if (index == 3) {
      this.setSumRecommend();
    }
  }

  isConfirm(flag: number) {
    return flag == 1;
  }

  textConfirm(flag: number) {
    return flag ? "確" : "未";
  }

  onEditPrice(frame: any) {
    if (!(this.sideTab[2].isActive || this.sideTab[3].isActive)) {
      const body = util.getWSData(frame);
      this.editPrice(body);
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedInspections
      });
      this.onUpdate(2);
      this.onUpdate(3);
    }
  }

  onPlus(index: number,event: any) {
    event.stopPropagation();
    this.$set(this.isOnPlus, index,  !this.isOnPlus[index]);
  }

  destroyed() {
    this.sktControll.freeSocketResources();
  }
}
